import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import { useWealthSavingsSecurityContent } from '../../../../hooks/useWealthSavingsSecurityContent';
import './Security.css';

const Security = () => {
  const { content, isLoading } = useWealthSavingsSecurityContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, items } = content;

  return (
    <section className="wealth-security">
      <div className="wealth-security__inner">
        <Reveal className="wealth-security__header">
          <h2 className="wealth-security__title">{title}</h2>
        </Reveal>

        <div className="wealth-security__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="wealth-security__card">
                {icon ? (
                  <div className="wealth-security__icon">
                    <img src={icon} alt="" aria-hidden="true" />
                  </div>
                ) : null}
                <h3 className="wealth-security__card-title">{itemTitle}</h3>
                <p className="wealth-security__card-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Security;
